var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"o-bg",style:(("--nav-height: " + _vm.navHeight + "px"))})}
var staticRenderFns = []

export { render, staticRenderFns }